import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTablePaginacion from "../useTablePaginacion";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../spinner";
import { formatMoneda } from "../../util/varios";
//import { MensajeRegistrarPago } from '../../components/registrarpagos/modalregistrarpagos';
import { Link } from "react-router-dom";
import FormTributario from "./formRegistroTribu";
import { Toasts } from "../toasts";

const TablaTributaria = (props) => {
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuariow = JSON.parse(localStorage.getItem("idusuarioweb"));

  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accopestadal = JSON.parse(localStorage.getItem("accopestadal"));
  let municipios = [];

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD.",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CED. / RIF.",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "NOMBRE / RAZÓN SOCIAL",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA INSCRIPCION",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];
  const [datos, setDatos] = useState([]);
  const [ret, setRet] = useState({
    cedula: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    apellidos: "",
    direccion: "",
    fnacimiento: "",
    nacionalidad: "",
    nombres: "",
    sexo: "",
  });
  const [records, setRecords] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTablePaginacion(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    let st = "";
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.txtidret.includes(target.value) ||
              x.txtrazonsocial
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.txtrif.toLowerCase().includes(target.value.toLowerCase()) ||
              x.txtfechainscripcion
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  var estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 1)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 1)",
    },
  };

  const txtBuscador = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [timbre, setTimbre] = useState(null);
  const [valorut, setValorut] = useState(0.0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [tab, setTab] = useState(1);
  const [entes, setEntes] = useState([]);
  const [dependencias, setDependencias] = useState([]);
  const [tramites, setTramites] = useState([]);
  const [tipoPago, setTipoPago] = useState("");
  const [catiDepo, setCantiDepo] = useState("0");
  const [efectivo1, setEfectivo1] = useState("0,00");
  const [efectivo2, setEfectivo2] = useState("0,00");
  const [fechaD1, setFechaD1] = useState("");
  const [fechaD2, setFechaD2] = useState("");
  const [numeroD1, setNumeroD1] = useState("");
  const [numeroD2, setNumeroD2] = useState("");
  const [montoT1, setMontoT1] = useState("0,00");
  const [montoT2, setMontoT2] = useState("0,00");
  const [montoT3, setMontoT3] = useState("0,00");
  const [fechaT1, setFechaT1] = useState("");
  const [fechaT2, setFechaT2] = useState("");
  const [fechaT3, setFechaT3] = useState("");
  const [numeroT1, setNumeroT1] = useState("");
  const [numeroT2, setNumeroT2] = useState("");
  const [numeroT3, setNumeroT3] = useState("");
  const [banCliT1, setBanCliT1] = useState("0");
  const [banCliT2, setBanCliT2] = useState("0");
  const [banCliT3, setBanCliT3] = useState("0");
  const [cuentasBanca, setCuentasBanca] = useState("0");
  const [values, setValues] = useState({
    idsolicitud: "",
    concepto: "",
    seleccionados: 0,
    credito: "0,00",
    total: "0,00",
  });

  const imprimirPago = (item) => (event) => {
    event.preventDefault();

    var titulo = item.txtestatus === 1 ? "Certificado de Pago Electrónico" : "";
    var estatus = item.txtestatus === 1 ? "'-2'" : "'0'";
    var certificado = item.txtestatus === 1 ? "true" : "false";
    var tipo = item.txttipotransaccion === 1 ? "Depo" : "Trans";

    window.open(
      op.reportes +
        "FACTURA=" +
        item.txtidfact +
        "&titulo=" +
        titulo +
        "&estatus=" +
        estatus +
        "&certificado=" +
        certificado +
        "&reporte=" +
        tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirTimbre = (item) => (e) => {
    e.preventDefault();
    var id = item.txtidret;
    window.open(
      op.reportes + "reporte=Ret" + "&IDSOLICITUD=" + id,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const getValorUTE = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/valorute/vervalorute`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setValorut(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const getSolicitudes = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/ret`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data[0].txtidret !== null) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar3(false);
    setCuentasBanca("0");
    setTipoPago("");
    setCantiDepo("0");
    setEfectivo1("0,00");
    setFechaD1("");
    setNumeroD1("");
    setEfectivo2("0,00");
    setFechaD2("");
    setNumeroD2("");
    setFechaT1("");
    setNumeroT1("");
    setBanCliT1("0");
    setMontoT1("0,00");
    setFechaT2("");
    setNumeroT2("");
    setBanCliT2("0");
    setMontoT2("0,00");
    setFechaT3("");
    setNumeroT3("");
    setBanCliT3("0");
    setMontoT3("0,00");
    setEntes([]);
    setDependencias([]);
    setTramites([]);
    setValues({
      idsolicitud: "",
      concepto: "",
      seleccionados: 0,
      credito: "0,00",
      total: "0,00",
    });
  };

  const registrarpago = (item) => (e) => {
    e.preventDefault();

    let concepto = "PAGO DE REGISTRO ESTADAL TRIBUTARIO :";
    concepto = concepto + item.txtrif + "-" + item.txtrazonsocial;

    setValues({
      idsolicitud: item.txtidret,
      concepto: concepto,
      seleccionados: 1,
      credito: "0,00",
      total: formatMoneda(
        item.txtmonto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      ),
    });
    setMostrar3(true);
  };

  const validar = (
    cuenta,
    tipopago,
    cantidepo,
    efecti1,
    fecdepo1,
    numdepo1,
    efecti2,
    fecdepo2,
    numdepo2,
    fect1,
    numt1,
    bcli1,
    mont1,
    fect2,
    numt2,
    bcli2,
    mont2,
    fect3,
    numt3,
    bcli3,
    mont3
  ) => {
    setCuentasBanca(cuenta);
    setTipoPago(tipopago);
    setCantiDepo(cantidepo);
    setEfectivo1(efecti1);
    setFechaD1(fecdepo1);
    setNumeroD1(numdepo1);
    setEfectivo2(efecti2);
    setFechaD2(fecdepo2);
    setNumeroD2(numdepo2);
    setFechaT1(fect1);
    setNumeroT1(numt1);
    setBanCliT1(bcli1);
    setMontoT1(mont1);
    setFechaT2(fect2);
    setNumeroT2(numt2);
    setBanCliT2(bcli2);
    setMontoT2(mont2);
    setFechaT3(fect3);
    setNumeroT3(numt3);
    setBanCliT3(bcli3);
    setMontoT3(mont3);

    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Esta Seguro de Registrar El Pago.",
      icono: "confirmacion",
    });
  };

  const getSolicitudTimbre = (item) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/solicitudtimbre/solicitud?id=${item.txtidsolicitud}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setTimbre(response.data);
        } else {
          setTimbre(null);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const getSolicitudRet = (ope, item) => {
    let campos = "*";
    let nomtab = "ret";
    let nomid = "idret";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${item.txtidret}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRet(response.data);
          setShowModal(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const getSolicitud = (op, item) => (e) => {
    if (op === 4) {
      setOperacion(4);
      getSolicitudTimbre(item);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      getSolicitudTimbre(item);
    } else if (op === 3) {
      setOperacion(op);
      getSolicitudTimbre(item);
    }
  };

  const procesarpago = (body) => {
    let endpoint = `${op.conexion}/api/agenteweb/procesarpago`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.factura !== null) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Estimado contribuyente, hacemos de su conocimiento que el procedimiento de verificación de pago tiene un tiempo estimado de 72 horas, una vez conciliado el mismo, será enviado vía correo electrónico, el correspondiente certificado de pago definitivo; valoramos y agradecemos su contribución para lograr el Municipio de lo Posible.",
              icono: "exito",
            });
            var idfactura = response.data.factura;
            var titulo =
              response.data.statusfac === 1
                ? "Certificado de Pago Electrónico"
                : "";
            var estatus = response.data.statusfac === 1 ? "'-2'" : "0";
            var certificado = response.data.statusfac === 1 ? "true" : "false";
            var tipo = response.data.tipotran === 1 ? "Depo" : "Trans";

            window.open(
              op.reportes +
                "FACTURA=" +
                idfactura +
                "&titulo=" +
                titulo +
                "&estatus=" +
                estatus +
                "&certificado=" +
                certificado +
                "&reporte=" +
                tipo,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "El pago no pudo ser Registrado.",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarPagoWeb = () => {
    var a = parseInt(moment(fechaSistema).format("YYYY"));
    var m = parseInt(moment(fechaSistema).format("MM"));
    var v = values.total.replace(/\./g, "").replace(",", ".");
    var nAnio = [a];
    var nMes = [m];
    var nMonto = [v];
    var nInteres = [0.0];
    var nMulta = [0.0];
    var nRecargo = [0.0];
    var nTotal = [v];
    var tdeu = [4];
    var iddeu = [values.idsolicitud];
    var tipod = [1];

    var tipPago = tipoPago === "deposito" ? 1 : 2;

    var body = {
      idcontri: idusuariow,
      fechasis: fechaSistema,
      idimpu: "6",
      mont: values.total.replace(/\./g, "").replace(",", "."),
      tipo: tipPago,
      cuenta: cuentasBanca,
      totaldescuento: "0.00",
      txtfecha1:
        fechaD1 === "" ? fechaD1 : moment(fechaD1).format("YYYY-MM-DD"),
      txtnumdepo1: numeroD1,
      txtmontoefec1: efectivo1.replace(/\./g, "").replace(",", "."),
      txtfecha2:
        fechaD2 === "" ? fechaD2 : moment(fechaD2).format("YYYY-MM-DD"),
      txtnumdepo2: numeroD2,
      txtmontoefec2: efectivo2.replace(/\./g, "").replace(",", "."),
      txtfechatran1:
        fechaT1 === "" ? fechaT1 : moment(fechaT1).format("YYYY-MM-DD"),
      txtnumtran1: numeroT1,
      bcliente1: banCliT1,
      txtmontotran1: montoT1.replace(/\./g, "").replace(",", "."),
      txtfechatran2:
        fechaT2 === "" ? fechaT2 : moment(fechaT2).format("YYYY-MM-DD"),
      txtnumtran2: numeroT2,
      bcliente2: banCliT2,
      txtmontotran2: montoT2.replace(/\./g, "").replace(",", "."),
      txtfechatran3:
        fechaT3 === "" ? fechaT3 : moment(fechaT3).format("YYYY-MM-DD"),
      txtnumtran3: numeroT3,
      bcliente3: banCliT3,
      txtmontotran3: montoT3.replace(/\./g, "").replace(",", "."),
      ctotmonto: values.total.replace(/\./g, "").replace(",", "."),
      ctotint: 0.0,
      ctotrec: 0.0,
      ctotmulta: 0.0,
      ctotrete: 0.0,
      txtconcepto: values.concepto,
      panio: nAnio,
      pmes: nMes,
      pmonto: nMonto,
      pinteres: nInteres,
      pmulta: nMulta,
      precargo: nRecargo,
      ptotal: nTotal,
      tdeu,
      iddeu,
      tipod,
    };

    procesarpago(body);
  };

  const handleCloseSi = () => {
    procesarPagoWeb();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    blanquear();
    getSolicitudes();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {
    if (document.getElementById("titulocabecera")) {
      document.getElementById("titulocabecera").innerHTML =
        "Registro Estadal Tributario";
    }
    getValorUTE();
    getSolicitudes();
  }, []);

  const cambiar = (op, item) => (e) => {
    e.preventDefault();
    setOperacion(op);

    if (op === 4) {
      if (accopestadal.substring(0, 1) !== "0") {
        getSolicitudRet(op, item);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accopestadal.substring(1, 2) !== "0") {
        setShowModal(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accopestadal.substring(2, 3) !== "0") {
        getSolicitudRet(op, item);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accopestadal.substring(3, 4) !== "0") {
        getSolicitudRet(op, item);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  return (
    <div className="h-100 w-100">
      <div className="row col-md-12 m-0">
        <div className="row col-md-12 m-0">
          <div className="col-md-12 mx-auto py-3">
            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                {/*                 <Link
                  to="/inicio"
                  title='volver a la pagina de inicio'
                  className="col-md-2 btn btn-sm btn-info rounded-pill">
                  <i className="fas fa-home  fa-fw text-white" /> inicio
                </Link> */}
                <input
                  type="text"
                  className=" col-md-2 form-control form-control-sm rounded-pill"
                  onChange={handleSearch}
                  placeholder="Buscar"
                />

                {/*                 <button title='agregar un registro estadal tributario' onClick={cambiar(1, '')} className={accopestadal && accopestadal.substring(1,2) === '0' ? "col-md-2 btn btn-sm btn-secondary rounded-pill" : "col-md-2 btn btn-sm btn-primary rounded-pill" }><i className="fas fa-plus"> agregar registro</i> </button> */}
              </div>
            </div>
            <div className="col-md-12 m-0">
              <TblContainer>
                <TblHead />
                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) =>
                      item.txtdenominacioncomercial === "8" ? (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                              borderLeft: "none",
                            }}
                          >
                            {item.txtidret}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {item.txtrif}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "start",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {item.txtrazonsocial}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {moment(item.txtfechainscripcion).format(
                              "DD-MM-YYYY"
                            )}
                          </TableCell>

                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            <p className="text-success text-center text-bold">
                              Procesada
                            </p>
                          </TableCell>
                          <TableCell
                            className="align-baseline d-flex justify-content-between"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                              borderRight: "none",
                            }}
                          >
                            <button
                              onClick={cambiar(4, item)}
                              title="Consultar registro estadal tributario"
                              className={
                                accopestadal &&
                                accopestadal.substring(0, 1) === "0"
                                  ? "btn btn-sm btn-secondary rounded-pill"
                                  : "btn btn-sm btn-info rounded-pill"
                              }
                            >
                              <i className="fas fa-eye"> Consultar</i>
                            </button>
                            <button
                              title="imprimir planilla de registro estadal tributario"
                              onClick={imprimirTimbre(item)}
                              className="btn btn-sm btn-primary rounded-pill"
                            >
                              <i className="fas fa-print"> PLANILLA</i>
                            </button>
                          </TableCell>
                        </TableRow>
                      ) : (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                              borderLeft: "none",
                            }}
                          >
                            {item.txtidret}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {item.txtrif}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "start",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {item.txtrazonsocial}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {moment(item.txtfechainscripcion).format(
                              "DD-MM-YYYY"
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {item.txtestatus === 0 ? (
                              <p className="text-danger text-center text-bold">
                                Por Pagar
                              </p>
                            ) : (
                              <button
                                onClick={imprimirPago(item)}
                                title={
                                  item.txtestatus === 2
                                    ? "el pago esta siendo verificado."
                                    : item.txtestatus === 1
                                    ? "procesada"
                                    : ""
                                }
                                className="align-baseline m-0 btn btn-sm btn-primary rounded-pill"
                              >
                                <i className="fas fa-print"> IMPRIMIR PAGO</i>
                              </button>
                            )}
                          </TableCell>
                          {item.txtestatus === 1 ? (
                            <TableCell
                              className="align-baseline d-flex justify-content-between"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                border: "solid 1px blue",
                                borderRight: "none",
                              }}
                            >
                              <button
                                onClick={cambiar(4, item)}
                                title="Consultar registro estadal tributario"
                                className="btn btn-sm btn-info rounded-pill"
                              >
                                <i className="fas fa-eye"> Consultar</i>
                              </button>
                              <button
                                onClick={imprimirTimbre(item)}
                                title="imprimir planilla de registro estadal tributario"
                                className="btn btn-sm btn-primary rounded-pill"
                              >
                                <i className="fas fa-print"> PLANILLA</i>
                              </button>
                            </TableCell>
                          ) : item.txtestatus === 0 ? (
                            <TableCell className="align-baseline d-flex justify-content-between">
                              <button
                                onClick={cambiar(4, item)}
                                title="Consultar registro estadal tributario"
                                className={
                                  accopestadal &&
                                  accopestadal.substring(0, 1) === "0"
                                    ? "btn btn-sm btn-secondary rounded-pill"
                                    : "btn btn-sm btn-info rounded-pill"
                                }
                              >
                                <i className="fas fa-eye"> Consultar</i>
                              </button>
                              {/*                               <button
                                onClick={cambiar(2, item)}
                                title="Modificar registro estadal tributario"
                                className={
                                  accopestadal &&
                                  accopestadal.substring(2, 3) === "0"
                                    ? "btn btn-sm btn-secondary rounded-pill"
                                    : "btn btn-sm btn-warnig rounded-pill"
                                }
                              >
                                <i className="fas fa-edit"> Modificar</i>
                              </button> */}
                              <button
                                onClick={cambiar(3, item)}
                                title="Eliminar registro estadal tributario"
                                className={
                                  accopestadal &&
                                  accopestadal.substring(3, 4) === "0"
                                    ? "btn btn-sm btn-secondary rounded-pill"
                                    : "btn btn-sm btn-danger rounded-pill"
                                }
                              >
                                <i className="fas fa-trash"> Eliminar</i>
                              </button>
                            </TableCell>
                          ) : (
                            <TableCell className="align-baseline d-flex justify-content-center">
                              <button
                                onClick={cambiar(4, item)}
                                title="Consultar registro estadal tributario"
                                className={
                                  accopestadal &&
                                  accopestadal.substring(0, 1) === "0"
                                    ? "btn btn-sm btn-secondary rounded-pill"
                                    : "btn btn-sm btn-info rounded-pill"
                                }
                              >
                                <i className="fas fa-eye"> Consultar</i>
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      )
                    )}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>

      {/*       <MensajeRegistrarPago concepto={values}
        show={mostrar3} fechasistema={fechaSistema}
        onHideAcepta={validar} onHideCancela={() => setMostrar3(false)} /> */}

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />

      <FormTributario
        ret={ret}
        operacion={operacion}
        show={showModal}
        onHide={(x) => {
          if (x) {
            getSolicitudes();
          }
          setShowModal(false);
        }}
      />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaTributaria;



// WEBPACK FOOTER //
// ./src/components/registroEstadalTributario/tablaEstadalTributaria.js